import { PortalAccessProfile } from "types/api";
import { canAccessPortalPath } from "utils/portal-access";

export type TeamsWorkspaceMode = "global" | "restricted";

export type TeamsWorkspaceContent = {
  mode: TeamsWorkspaceMode;
  pageDescription: string;
  emptyDescription: string;
  emptyTitle: string;
  profileDescription: string;
  rosterSubtitle: string;
  showManagementActions: boolean;
};

export const canAccessGlobalTeamsCatalog = (portalAccess?: PortalAccessProfile | null) =>
  canAccessPortalPath("/teams", portalAccess);

export const getTeamsWorkspaceContent = (
  portalAccess?: PortalAccessProfile | null,
  canManageTeams = false,
): TeamsWorkspaceContent => {
  if (canManageTeams || canAccessGlobalTeamsCatalog(portalAccess)) {
    return {
      mode: "global",
      pageDescription:
        "Manage club and representative squads, including their sport alignment, status, and country coverage.",
      emptyDescription: "Add a team to begin grouping athletes under a shared organization.",
      emptyTitle: "No teams match these filters",
      profileDescription:
        "Track a squad's core metadata and see every athlete currently linked to it.",
      rosterSubtitle: "Athletes linked to this team",
      showManagementActions: true,
    };
  }

  return {
    mode: "restricted",
    pageDescription:
      "Global team access is limited for your role. Use the School Teams workspace for role-scoped squads and rosters.",
    emptyDescription:
      "Your role does not expose the platform-wide team catalog. Use the School Teams workspace instead.",
    emptyTitle: "Global team catalog unavailable",
    profileDescription:
      "Global team profiles are limited for your role. Use the School Teams workspace for team-specific school operations.",
    rosterSubtitle: "Global roster access is limited for this role",
    showManagementActions: false,
  };
};
